import { CircleX } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionReject(props) {

    const { text, route_name, onClick, skipPermission = false } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))
    const canShow = skipPermission || permission?.some(val => val.sub_action_name === route_name)

    return (
        <>
            {canShow &&
                <CircleX size={16} className='action_btn text-danger me-3'
                    onClick={onClick}
                    data-tooltip-id='reject'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                />
            }

            <Tooltip id='reject' className='bg-danger tooltip_msg' />
        </>
    )
}
